import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { useRouter } from 'vue-router'
import { useMixpanel } from '@/tracking'

const STORE_KEY = 'protargeting-theme'

export const useThemeStore = defineStore(STORE_KEY, () => {
  const router = useRouter()
  const { track } = useMixpanel()

  const onDashboard = computed(() => {
    return (
      router.currentRoute.value.meta.layout === 'dashboard' ||
      router.currentRoute.value.meta.layout === 'dashboard-no-nav'
    )
  })

  const internalBlack = ref(false)
  const black = computed(() => {
    if (process.env.MODE === 'test') return false
    if (onDashboard.value) return false

    return internalBlack.value
  })

  function syncTheme(_black?: boolean, _track?: boolean) {
    if (_track) {
      track('XProTargeting Theme Toggled', {
        theme: _black ? 'dark' : 'light',
      })
    }

    if (onDashboard.value) _black = false

    const theme = _black ?? (localStorage.getItem('themenew') === 'dark' || localStorage.getItem('themenew') === null)

    internalBlack.value = !!theme

    if (!internalBlack.value) {
      document.documentElement.classList.remove('dark')
    }

    if (internalBlack.value) {
      document.documentElement.classList.add('dark')
    }

    localStorage.setItem('themenew', internalBlack.value ? 'dark' : 'light')
  }

  syncTheme()

  return { black, syncTheme }
})
